export const fetchPipelineUsageAction = 'fetchPipelineUsageAction';
export const fetchTotalPipelineUsageAction = 'fetchTotalPipelineUsageAction';
export const fetchAvgPipelineUsageAction = 'fetchAvgPipelineUsageAction';
export const fetchPipelineCollectionUsageAction =
  'fetchPipelineCollectionUsageAction';
